import {
  ControlBar,
  ControlBarButton,
  VideoTileGrid,
  useContentShareControls,
  useContentShareState,
  useLocalVideo,
  useToggleLocalMute,
} from 'amazon-chime-sdk-component-library-react'
import { useTranslation } from 'react-i18next'
import {
  FaMicrophone,
  FaMicrophoneSlash,
  FaVideo,
  FaVideoSlash,
} from 'react-icons/fa'
import { LuScreenShare } from 'react-icons/lu'
import styled from 'styled-components'

import { useMeetingBackground } from '../../hooks'

const Container = styled.div`
  box-shadow: 0 0.75rem 1.875rem 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const Video = styled.div`
  flex: 1;
  min-height: 0;
  border: 1px solid #f0f0f0;
`

const Control = styled(ControlBarButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ControlIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 5px;
`

const StyledControlBar = styled(ControlBar)`
  width: 100%;
  gap: 2rem;
  flex-shrink: 0;
`

export function VideoContainer({
  onLeaveMeeting,
}: {
  onLeaveMeeting: () => void
}) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'page.meeting',
  })

  const { toggleVideo, isVideoEnabled } = useLocalVideo()
  const { toggleMute, muted } = useToggleLocalMute()
  const { toggleContentShare } = useContentShareControls()
  const { isLocalUserSharing } = useContentShareState()
  useMeetingBackground()

  return (
    <Container>
      <Video>
        <VideoTileGrid />
      </Video>
      <StyledControlBar showLabels layout="undocked-horizontal">
        <Control
          icon={
            <ControlIcon>
              {muted ? <FaMicrophoneSlash /> : <FaMicrophone />}
            </ControlIcon>
          }
          onClick={toggleMute}
          label={t('mute')}
        />
        <Control
          icon={
            <ControlIcon>
              {isVideoEnabled ? <FaVideo /> : <FaVideoSlash />}
            </ControlIcon>
          }
          onClick={toggleVideo}
          label={t('startVideo')}
        />
        <Control
          icon={
            <ControlIcon>
              <LuScreenShare />
            </ControlIcon>
          }
          onClick={toggleContentShare}
          label={isLocalUserSharing ? 'Stop Sharing' : t('shareScreen')}
        />
        <button onClick={onLeaveMeeting}>{t('leave')}</button>
      </StyledControlBar>
    </Container>
  )
}
